import { render, staticRenderFns } from "./ScientificDegreeAdd.vue?vue&type=template&id=4c42a358&scoped=true&"
import script from "./ScientificDegreeAdd.vue?vue&type=script&lang=js&"
export * from "./ScientificDegreeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c42a358",
  null
  
)

export default component.exports